import React, { useState, useEffect } from "react";
import { Navbar, Nav, Form, FormControl, Button } from "react-bootstrap";
import tmlogo from "../images/tmlogo.png";
import digitalfair from "../images/digitalfair.png";
import AddBoxIcon from "@material-ui/icons/AddBox";
import IndeterminateCheckBoxIcon from "@material-ui/icons/IndeterminateCheckBox";
import HomeRoundedIcon from "@material-ui/icons/HomeRounded";
import "./HomePageSvg";
import HomePageSvg from "./HomePageSvg";
import "./HomePage.css";
import { MapInteractionCSS } from "react-map-interaction";
import { useMediaQuery } from "react-responsive";

function HomePage() {
  const isDesktopOrLaptop = useMediaQuery({ minDeviceWidth: 1366 });
  const isBigScreen = useMediaQuery({ minDeviceWidth: 1824 });
  const isMobileDevice = useMediaQuery({ maxDeviceWidth: 767 });
  const isTabletDevice = useMediaQuery({
    minDeviceWidth: 768,
    maxDeviceWidth: 1224,
  });

  const [svgWidth, setSvgWidth] = useState("758");
  const [svgMinWidth, setSvgMinWidth] = useState(12);
  const [homeSvgWidth, setHomeSvgWidth] = useState("1198");
  const [homeSvgHeight, setHomeSvgHeight] = useState("664");
  const [homeSvgMinWidth, setHomeSvgMinWidth] = useState(812);
  const [homeSvgMinHeight, setHomeSvgMinHeight] = useState(278);

  return (
    <div>
      <Navbar
        style={{ background: "#E72129" }}
        className="text-align-center"
        expand="lg"
      >
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            <Nav.Link
              style={{ color: "white", fontWeight: "bold", fontSize: 20 }}
              href="#home"
            >
              Home
            </Nav.Link>
            <Nav.Link
              style={{ color: "white", fontWeight: "bold", fontSize: 20 }}
              href="#link"
            >
              Link
            </Nav.Link>
            <Nav.Link
              style={{ color: "white", fontWeight: "bold", fontSize: 20 }}
              href="#events"
            >
              Events
            </Nav.Link>
            <Nav.Link
              style={{ color: "white", fontWeight: "bold", fontSize: 20 }}
              href="#exhibitors"
            >
              Exhibitors
            </Nav.Link>
            <Nav.Link
              style={{ color: "white", fontWeight: "bold", fontSize: 20 }}
              href="#account"
            >
              My Account
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <br />
      <br />
      <div style={{ width: "auto", marginLeft: 20, marginRight: 20 }}>
        <img style={{ height: "auto", maxWidth: "100%" }} src={tmlogo} />
        <br />
        <img style={{ height: "auto", maxWidth: "100%" }} src={digitalfair} />
      </div>
      {/* */}
      <div>
        {/* <AddBoxIcon
        style={{
          cursor: "pointer",
          color: "#E62128",
          fontSize: 40,
        }}
        onClick={() => {
          setSvgWidth((parseInt(svgWidth) + 200).toString());
          //   setSvgHeight((parseInt(svgHeight) + 200).toString());
        }}
      />

      <IndeterminateCheckBoxIcon
        style={{
          cursor: "pointer",
          color: "#E62128",
          fontSize: 40,
        }}
        onClick={() => {
          if (svgWidth > svgMinWidth) {
            setSvgWidth((parseInt(svgWidth) - 200).toString());
            // setSvgHeight((parseInt(svgHeight) - 200).toString());
          }
        }}
      /> */}
        {isDesktopOrLaptop && (
          <div
            style={{
              maxWidth: "1400px",
              margin: "40px auto 0 auto",
              padding: "20px 50px",
              display: "flex",
            }}
          >
            <div
              style={{
                flex: 0.5,
                order: 1,
              }}
            >
              <div>
                <AddBoxIcon
                  style={{
                    cursor: "pointer",
                    color: "#E62128",
                    fontSize: 40,
                  }}
                  onClick={() => {
                    setSvgWidth((parseInt(svgWidth) + 200).toString());
                    //   setSvgHeight((parseInt(svgHeight) + 200).toString());
                  }}
                />
                <br />
                <IndeterminateCheckBoxIcon
                  style={{
                    cursor: "pointer",
                    color: "#E62128",
                    fontSize: 40,
                  }}
                  onClick={() => {
                    if (svgWidth > svgMinWidth) {
                      setSvgWidth((parseInt(svgWidth) - 200).toString());
                      // setSvgHeight((parseInt(svgHeight) - 200).toString());
                    }
                  }}
                />
              </div>
            </div>
            <div
              style={{
                flex: 18,
                order: 2,
              }}
            >
              <div
                className="position-static"
                style={{ width: "auto", height: 600 }}
              >
                <MapInteractionCSS disableZoom={true}>
                  <HomePageSvg svgWidth={svgWidth} svgMinWidth={svgMinWidth} />
                </MapInteractionCSS>
              </div>
            </div>
            <div style={{ flex: 0.5, order: 3 }}></div>
          </div>
        )}
        {isTabletDevice && (
          <div
            style={{
              maxWidth: "1400px",
              margin: "40px auto 0 auto",
              padding: "20px 50px",
              display: "flex",
            }}
          >
            <div style={{ flex: 0.5, order: 1 }}>
              <div>
                <AddBoxIcon
                  style={{
                    cursor: "pointer",
                    color: "#E62128",
                    fontSize: 40,
                  }}
                  onClick={() => {
                    setSvgWidth((parseInt(svgWidth) + 200).toString());
                    //   setSvgHeight((parseInt(svgHeight) + 200).toString());
                  }}
                />
                <br />
                <IndeterminateCheckBoxIcon
                  style={{
                    cursor: "pointer",
                    color: "#E62128",
                    fontSize: 40,
                  }}
                  onClick={() => {
                    if (svgWidth > svgMinWidth) {
                      setSvgWidth((parseInt(svgWidth) - 200).toString());
                      // setSvgHeight((parseInt(svgHeight) - 200).toString());
                    }
                  }}
                />
              </div>
            </div>
            <div
              style={{
                flex: 5,
                order: 2,
              }}
            >
              <div
                className="position-static"
                style={{ width: "auto", height: 600 }}
              >
                <MapInteractionCSS disableZoom={true}>
                  <HomePageSvg svgWidth={svgWidth} svgMinWidth={svgMinWidth} />
                </MapInteractionCSS>
              </div>
            </div>
            <div style={{ flex: 0.5, order: 3 }}></div>
          </div>
        )}
        {isMobileDevice && (
          <div
            style={{
              maxWidth: "1400px",
              margin: "40px auto 0 auto",
              padding: "20px 50px",
              display: "flex",
            }}
          >
            <div style={{ flex: 0.5, order: 1 }}>
              <div style={{ marginLeft: -40 }}>
                <AddBoxIcon
                  style={{
                    cursor: "pointer",
                    color: "#E62128",
                    fontSize: 25,
                  }}
                  onClick={() => {
                    setSvgWidth((parseInt(svgWidth) + 200).toString());
                    //   setSvgHeight((parseInt(svgHeight) + 200).toString());
                  }}
                />
                <br />
                <IndeterminateCheckBoxIcon
                  style={{
                    cursor: "pointer",
                    color: "#E62128",
                    fontSize: 25,
                  }}
                  onClick={() => {
                    if (svgWidth > svgMinWidth) {
                      setSvgWidth((parseInt(svgWidth) - 200).toString());
                      // setSvgHeight((parseInt(svgHeight) - 200).toString());
                    }
                  }}
                />
              </div>
            </div>
            <div
              style={{
                flex: 18,
                order: 2,
              }}
            >
              <div
                className="position-static"
                style={{ width: "auto", height: 300 }}
              >
                <MapInteractionCSS disableZoom={true}>
                  <HomePageSvg svgWidth={svgWidth} svgMinWidth={svgMinWidth} />
                </MapInteractionCSS>
              </div>
            </div>
            <div style={{ flex: 0.5, order: 3 }}></div>
          </div>
        )}

        {/* <MapInteractionCSS disableZoom={true}>
        <HomePageSvg svgWidth={svgWidth} svgMinWidth={svgMinWidth} />
      </MapInteractionCSS> */}
      </div>
    </div>
  );
}

export default HomePage;
